import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import './header.scss';
// import logo from '../assets/img/svg/logo_full_color.svg';
import logo from '../assets/logo.jpeg';
import Drawer from '@mui/material/Drawer';
import LanguageSwitcher from './languageSwitcher';

const Header = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const MenuItems = () => {
    return (
      <div className={`nav-link-container`}>
        <div className="menu-icon close-menu-icon" onClick={toggleDrawer(false)}>
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="M6 6L18 18M6 18L18 6" stroke="#083D6E" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>
        <Link className="nav-link link-no-style link-blue" to="/about">
          <span className="header-link">{t('nav.about')}</span>
        </Link>
        <Link className="nav-link link-no-style link-blue" to="/services">
          <span className="header-link">{t('nav.services')}</span>
        </Link>
        <Link className="nav-link link-no-style link-blue" to="/fleet">
          <span className="header-link">{t('nav.fleet')}</span>
        </Link>
        <Link className="nav-link link-no-style link-blue" to="/contact">
          <span className="header-link">{t('nav.contact')}</span>
        </Link>
        <LanguageSwitcher />
      </div>
    );
  };

  return (
    <div className="nav-bar">
      <div className="nav-bar-content main-content-container">
        <Link className="logo-home-link" to="/" aria-label="homepage">
          <img className="logo-img" src={logo} alt="Company Logo" />
        </Link>
        <div className="menu-icon" onClick={toggleDrawer(true)}>
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="M3 6h18M3 12h18M3 18h18" stroke="#083D6E" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>
        <div className="not-hidden">
          <MenuItems />
        </div>
        <Drawer 
          open={open} 
          onClose={toggleDrawer(false)}
          anchor="right"
        >
          <MenuItems />
        </Drawer>
      </div>
    </div>
  );
};

export default Header;
